module.exports = __webpack_public_path__ + "static/media/corporate-services-img2.31425d5b.jpg";